"use client";

import { useState } from "react";
import { Check, Copy } from "@/components/icons";
import { IconButton } from "@/components/ui/icon-button";
import {
  gatherClientDiagnostics,
  formatDiagnosticsMarkdown,
} from "@/lib/feedback/client-diagnostics";

async function copyDiagnostics(
  error: Error & { digest?: string },
  onCopied: () => void,
) {
  const markdown = formatDiagnosticsMarkdown(gatherClientDiagnostics(), {
    message: error.message,
    digest: error.digest,
    stack: error.stack,
  });
  try {
    await navigator.clipboard.writeText(markdown);
    onCopied();
  } catch {
  }
}

export function CopyDiagnosticsButton({
  error,
  className,
}: {
  error: Error & { digest?: string };
  className?: string;
}) {
  const [copied, setCopied] = useState(false);

  return (
    <IconButton
      variant="quiet"
      size="dense"
      aria-label={copied ? "Error details copied" : "Copy error details"}
      title="Copy error details"
      className={className}
      onClick={() =>
        copyDiagnostics(error, () => {
          setCopied(true);
          setTimeout(() => setCopied(false), 2000);
        })
      }
    >
      {copied ? <Check className="size-3.5" /> : <Copy className="size-3.5" />}
    </IconButton>
  );
}
